// extracted by mini-css-extract-plugin
export default {"song_title":"SongName_song_title__qjvhy","song_artist":"SongName_song_artist__ipEBc"};